export const recursosFederales = [
    {
        'anio' : 'Ejercicio 2025',
        'trimestres' : [
            // {
            //     'trimestre' : 'Cierre de la cuenta pública',
            //     'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2025/SIPDUS-SHCP-5-2025.pdf',
            // },
            {
                'trimestre' : '4.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2025/SIPDUS-SHCP-4-2025.pdf',
            },
            {
                'trimestre' : '3.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2025/SIPDUS-SHCP-3-2025.pdf',
            },
            {
                'trimestre' : '2.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2025/SIPDUS-SHCP-2-2025.pdf',
            },
            {
                'trimestre' : '1.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2025/SIPDUS-SHCP-1-2025.pdf',
            },
        ]
    },
    {
        'anio' : 'Ejercicio 2024',
        'trimestres' : [
            {
                'trimestre' : 'Informe definitivo',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2024/SIPDUS-SHCP-5-2024.pdf',
            },
            {
                'trimestre' : '4.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2024/SIPDUS-SHCP-4-2024.pdf',
            },
            {
                'trimestre' : '3.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2024/SIPDUS-SHCP-3-2024.pdf',
            },
            {
                'trimestre' : '2.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2024/SIPDUS-SHCP-2-2024.pdf',
            },
            {
                'trimestre' : '1.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2024/SIPDUS-SHCP-1-2024.pdf',
            },
        ]
    },
    {
        'anio' : 'Ejercicio 2023',
        'trimestres' : [
            // {
            //     'trimestre' : 'Cierre de la cuenta pública',
            //     'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2023/SIPDUS-SHCP-5-2023.pdf',
            // },
            {
                'trimestre' : '4.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2023/SIPDUS-SHCP-4-2023.pdf',
            },
            {
                'trimestre' : '3.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2023/SIPDUS-SHCP-3-2023.pdf',
            },
            {
                'trimestre' : '2.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2023/SIPDUS-SHCP-2-2023.pdf',
            },
            {
                'trimestre' : '1.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2023/SIPDUS-SHCP-1-2023.pdf',
            },
        ]
    },
    {
        'anio' : 'Ejercicio 2022',
        'trimestres' : [
            {
                'trimestre' : 'Cierre de la cuenta pública',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2022/SOPOT-SHCP-5-2022.pdf',
            },
            {
                'trimestre' : '4.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2022/SOPOT-SHCP-4-2022.pdf',
            },
            {
                'trimestre' : '3.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2022/SOPOT-SHCP-3-2022.pdf',
            },
            {
                'trimestre' : '2.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2022/SOPOT-SHCP-2-2022.pdf',
            },
            {
                'trimestre' : '1.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2022/SOPOT-SHCP-1-2022.pdf',
            }
        ]
    },
    {
        'anio' : 'Ejercicio 2021',
        'trimestres' : [
            {
                'trimestre' : 'Cierre de la cuenta pública',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2021/SOPOT-SHCP-5-2021.pdf',
            },
            {
                'trimestre' : '4.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2021/SOPOT-SHCP-4-2021.pdf',
            },
            {
                'trimestre' : '3.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2021/SOPOT-SHCP-3-2021.pdf',
            },
            {
                'trimestre' : '2.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2021/SOPOT-SHCP-2-2021.pdf',
            },
            {
                'trimestre' : '1.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2021/SOPOT-SHCP-1-2021.pdf',
            }
        ]
    },
    {
        'anio' : 'Ejercicio 2020',
        'trimestres' : [
            {
                'trimestre' : 'Cierre de la cuenta pública',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2020/SOPOT-SHCP-5-2020.pdf',
            },
            {
                'trimestre' : '4.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2020/SOPOT-SHCP-4-2020.pdf',
            },
            {
                'trimestre' : '3.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2020/SOPOT-SHCP-3-2020.pdf',
            },
            {
                'trimestre' : '2.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2020/SOPOT-SHCP-2-2020.pdf',
            },
            {
                'trimestre' : '1.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2020/SOPOT-SHCP-1-2020.pdf',
            }
        ]
    },
    {
        'anio' : 'Ejercicio 2019',
        'trimestres' : [
            {
                'trimestre' : 'Cierre de la cuenta pública',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2019/SOPOT-SHCP-5-2019.pdf',
            },
            {
                'trimestre' : '4.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2019/SOPOT-SHCP-4-2019.pdf',
            },
            {
                'trimestre' : '3.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2019/SOPOT-SHCP-3-2019.pdf',
            },
            {
                'trimestre' : '2.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2019/SOPOT-SHCP-2-2019.pdf',
            },
            {
                'trimestre' : '1.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2019/SOPOT-SHCP-1-2019.pdf',
            }
        ]
    },
    {
        'anio' : 'Ejercicio 2018',
        'trimestres' : [
            {
                'trimestre' : 'Cierre de la cuenta pública',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2018/SOPOT-SHCP-5-2018.pdf',
            },
            {
                'trimestre' : '4.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2018/SOPOT-SHCP-4-2018.pdf',
            },
            {
                'trimestre' : '3.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2018/SOPOT-SHCP-3-2018.pdf',
            },
            {
                'trimestre' : '2.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2018/SOPOT-SHCP-2-2018.pdf',
            },
            {
                'trimestre' : '1.º Trimestre',
                'documento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/recfed/2018/SOPOT-SHCP-1-2018.pdf',
            }
        ]
    },
]